import { channelType, channelsKeniuTool } from '@/common/const.js'

export default {
  namespaced: true,
  state: () => ({
    channel: null,
    tryno: null
  }),
  getters: {
    // 是否是驱动精灵渠道，驱动精灵渠道使用公众号登录+驱动精灵，qq登录
    isChannelDg (state) {
      return state.channel === channelType.dg
    },
    isChannelDuba (state) {
      return state.channel === channelType.duba
    },
    // 是否是可牛工具渠道，可牛工具渠道使用公众号登录+完美微信，qq登录
    isChannelKeniuTools (state) {
      return channelsKeniuTool.includes(state.channel)
    }
  },
  mutations: {
    vuexChangeChannel (state, channel) { // 会员支付窗状态
      state.channel = channel
    },
    vuexChangeTryno (state, tryno) {
      state.tryno = tryno
    }
  }
}
